module.exports = __webpack_public_path__ + "img/owe.7f4ec933.svg";